import { useCallback } from 'react';
import { useRecoilState } from 'recoil';
import { SiteBanner } from '@state';
import { TSiteBannerConfig } from '@types';

export const useSiteBanner = () => {
	const [banner, setBanner] = useRecoilState(SiteBanner);

	const showBanner = useCallback((config: TSiteBannerConfig) => {
		setBanner(config);
	}, [setBanner]);

	const hideBanner = useCallback(() => {
		setBanner(null);
	}, [setBanner]);

	return {
		banner,
		isVisible: banner !== null,
		showBanner,
		hideBanner
	};
};
